module.exports = __webpack_public_path__ + "static/media/berkeley_logo.1dcf6b68.png";